export function SectionHeading({
  kicker,
  title,
  desc,
  align = "left",
}: {
  kicker: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}) {
  return (
    <div className={align === "center" ? "text-center" : ""}>
      <div
        className={
          "inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900 " +
          (align === "center" ? "mx-auto" : "")
        }
      >
        <span className="h-1.5 w-1.5 rounded-full bg-secondary-500"></span>
        {kicker}
      </div>
      <h2 className="font-heading mt-4 text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc ? (
        <p
          className={
            "mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base " +
            (align === "center" ? "mx-auto" : "")
          }
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}